import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, onSnapshot, setDoc } from "firebase/firestore";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let unsubscribeFirestore = null;

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      // Cancelar listener anterior de Firestore si existe
      if (unsubscribeFirestore) {
        unsubscribeFirestore();
        unsubscribeFirestore = null;
      }

      if (user) {
        const userRef = doc(db, "users", user.uid);

        // Listener en tiempo real: detecta cambios de status al instante
        unsubscribeFirestore = onSnapshot(
          userRef,
          async (docSnap) => {
            if (!docSnap.exists()) {
              await setDoc(userRef, {
                nickname: user.displayName || "",
                photoURL: user.photoURL || "",
                email: user.email || "",
                createdAt: new Date(),
              });
            }

            const userData = docSnap.exists() ? docSnap.data() : {};
            setCurrentUser({
              uid: user.uid,
              email: user.email,
              displayName: user.displayName,
              photoURL: user.photoURL,
              ...userData, // incluye status, carrera, role, nickname, etc.
            });
            setLoading(false);
          },
          (error) => {
            // Firestore rechazó la lectura (ej: reglas muy estrictas)
            console.error("AuthContext onSnapshot error:", error.code, error.message);
            // Aún así dejar al usuario con los datos básicos de Auth
            setCurrentUser({
              uid: user.uid,
              email: user.email,
              displayName: user.displayName,
              photoURL: user.photoURL,
            });
            setLoading(false);
          }
        );
      } else {
        setCurrentUser(null);
        setLoading(false);
      }
    });

    return () => {
      unsubscribeAuth();
      if (unsubscribeFirestore) unsubscribeFirestore();
    };
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
